/**
 * getTokenManager.ts
 * Utilitaire pour charger de manière asynchrone le TokenManager sans utiliser de hooks React
 * Ceci est spécifiquement conçu pour les services et modules qui ne font pas partie du cycle de vie React.
 */

// Version sans hooks pour les modules non-React
export async function getTokenManager() {
  try {
    const tokenModule = await import('../lib/auth/token-manager');
    return tokenModule.TokenManager;
  } catch (error) {
    console.error('❌ Erreur lors du chargement de TokenManager:', error);
    throw new Error('Impossible de charger TokenManager');
  }
}

// Exporter également une version synchrone pour les cas simples
// À utiliser avec précaution car elle peut retourner undefined si le module n'est pas encore chargé
let cachedTokenManager: any = null;

// Précharger le TokenManager dès l'importation de ce module
import('../lib/auth/token-manager')
  .then(module => {
    cachedTokenManager = module.TokenManager;
    console.log('🔐 TokenManager préchargé avec succès');
  })
  .catch(error => {
    console.error('❌ Erreur lors du préchargement de TokenManager:', error);
  });

export function getTokenManagerSync() {
  if (!cachedTokenManager) {
    console.warn('⚠️ TokenManager n\'est pas encore chargé, retourne null');
  }
  return cachedTokenManager;
}
